module.exports = __webpack_public_path__ + "static/key-redorchestra-5e197fa4cb5064eefdca5590237bc855.webp";